/*!
 * Upgrade Clinic — bundled custom JS (PROD without mega-menu)
 * Rolled back per content owner request 2026-05-25.
 */

;(function(){

(function () {
"use strict";
(function autoRedirect() {
function go() {
var el = document.querySelector("[data-redirect-to]");
if (el) {
var url = el.getAttribute("data-redirect-to");
if (url) window.location.replace(url);
}
}
if (document.readyState === "loading") {
document.addEventListener("DOMContentLoaded", go);
} else {
go();
}
})();
function init() {
var host = document.getElementById("anchor-nav-host");
var spacer = document.getElementById("anchor-nav-spacer");
if (!host || !spacer) return;
var origParent = host.parentNode;
var origNext = host.nextSibling;
var isFixed = false;
var lastY = window.pageYOffset;
var SHY_THRESHOLD = 6;
var links = Array.prototype.slice.call(host.querySelectorAll(".anchor-nav__link"));
var currentLabel = host.querySelector(".anchor-nav__current");
var labelById = {};
var sectionIds = links
.map(function (l) {
var h = l.getAttribute("href");
if (!h || h.charAt(0) !== "#") return null;
var id = h.slice(1);
labelById[id] = (l.textContent || "").trim();
return id;
})
.filter(Boolean);
function originalTop() {
var ref = isFixed ? spacer : host;
return ref.getBoundingClientRect().top + window.pageYOffset;
}
function measure() {
spacer.style.height = host.offsetHeight + "px";
}
function setFixed(state) {
if (state === isFixed) return;
if (state) {
spacer.classList.add("is-active");
document.body.appendChild(host);
host.classList.add("is-fixed");
} else {
host.classList.remove("is-fixed");
if (origNext && origNext.parentNode === origParent) {
origParent.insertBefore(host, origNext);
} else {
origParent.appendChild(host);
}
spacer.classList.remove("is-active");
}
isFixed = state;
}
function onScroll() {
var y = window.pageYOffset;
var trig = originalTop();
setFixed(y >= trig);
var delta = y - lastY;
if (isFixed && Math.abs(delta) > SHY_THRESHOLD) {
if (delta < 0) host.classList.add("is-hidden");
else host.classList.remove("is-hidden");
} else if (!isFixed) {
host.classList.remove("is-hidden");
}
lastY = y;
var checkY = y + host.offsetHeight + 40;
var current = null;
for (var i = 0; i < sectionIds.length; i++) {
var el = document.getElementById(sectionIds[i]);
if (!el) continue;
var top = el.getBoundingClientRect().top + y;
if (top <= checkY) current = sectionIds[i];
else break;
}
for (var j = 0; j < links.length; j++) {
var match = links[j].getAttribute("href") === "#" + current;
if (match) links[j].classList.add("is-active");
else links[j].classList.remove("is-active");
}
if (currentLabel && current && labelById[current]) {
currentLabel.textContent = labelById[current];
}
}
var ticking = false;
function onScrollThrottled() {
if (ticking) return;
ticking = true;
window.requestAnimationFrame(function () {
onScroll();
ticking = false;
});
}
measure();
window.addEventListener("scroll", onScrollThrottled, { passive: true });
window.addEventListener("resize", function () { measure(); onScroll(); }, { passive: true });
if (window.ResizeObserver) {
try { new ResizeObserver(measure).observe(host); } catch (e) {  }
}
onScroll();
setTimeout(function () { measure(); onScroll(); }, 100);
}
if (document.readyState === "loading") {
document.addEventListener("DOMContentLoaded", init);
} else {
init();
}
})();

})();

;(function(){

(function () {
"use strict";
var CDN = "//www.upgradeclinic.cz/cdn/shop/files/";
var ITEMS = [
{ title: "Botox", sub: "Vyhlazení mimických vrásek", url: "/pages/zakrok-botox", img: "Aplikace_botulotoxinu.jpg", kw: "botox botulotoxin mimika vrasky cela obroci ocni okoli" },
{ title: "Výplně rtů a kontury", sub: "Kyselina hyaluronová", url: "/pages/zakrok-vyplne-rtu-a-kontury", img: "vyplne.jpg", kw: "vyplne rty hyaluronova kontury filler" },
{ title: "Modelace tváře a kontur", sub: "Radiesse, výplně tváří", url: "/pages/zakrok-vyplne-tvari-a-kontur", img: "vyplne.jpg", kw: "modelace tvar kontury radiesse vyplne brada celist lici" },
{ title: "Sculptra", sub: "Stimulace vlastního kolagenu", url: "/pages/zakrok-sculptra", img: "Bioremodelace.jpg", kw: "sculptra kolagen polylactic stimulace kyselina polymlecna" },
{ title: "Profhilo", sub: "Bioremodelace, hydratace a zpevnění", url: "/pages/zakrok-profhilo-bioremodelace", img: "Bioremodelace.jpg", kw: "profhilo bioremodelace hydratace zpevneni krk dekolt ruce" },
{ title: "Biorevitalizace", sub: "Hydratační injekce", url: "/pages/zakrok-biorevitalizace", img: "Bioremodelace.jpg", kw: "biorevitalizace hydratace injekce mezoterapie" },
{ title: "Mezoterapie PDRN", sub: "Regenerace pleti DNA injekcemi", url: "/pages/zakrok-mezoterapie-pdrn", img: "Microneedling.jpg", kw: "mezoterapie pdrn polynukleotidy regenerace ocni okoli lososi" },
{ title: "Microneedling", sub: "Mikrojehličkování pleti", url: "/pages/zakrok-microneedling", img: "Microneedling.jpg", kw: "microneedling mikrojehlickovani jizvy akne pory strecove linie" },
{ title: "Chemický peeling", sub: "Obnovení povrchové vrstvy pleti", url: "/pages/zakrok-chemicky-peeling", img: "peeling.jpg", kw: "chemicky peeling pigmentace melasma akne tehotenstvi" },
{ title: "Cosmelan", sub: "Léčba pigmentových skvrn a melasmy", url: "/pages/zakrok-cosmelan", img: "lumecca.jpg", kw: "cosmelan melasma pigmentace skvrny hyperpigmentace" },
{ title: "Morpheus8", sub: "Mikrojehličkování s radiofrekvencí", url: "/pages/zakrok-morpheus8", img: "Microneedling.jpg", kw: "morpheus8 morpheus radiofrekvence rf microneedling zpevneni" },
{ title: "Ultraformer HIFU", sub: "Ultrazvukový lifting tváře a krku", url: "/pages/zakrok-ultraformer-hifu", img: "ultraformer_zoom.jpg", kw: "ultraformer hifu lifting ultrazvuk obroci ovaĺ" },
{ title: "Lumecca IPL", sub: "Fotoomlazení, pigmentace, cévky", url: "/pages/zakrok-lumecca-ipl", img: "lumecca.jpg", kw: "lumecca ipl pigmentace cevky ruzovka fotoomlazeni" },
{ title: "Fotona Laser 4D", sub: "Lifting, jizvy, NightLase", url: "/pages/zakrok-fotona-laser", img: "lumecca.jpg", kw: "fotona laser 4d nightlase chrapani jizvy pigmentace" },
{ title: "EXION", sub: "Zpevnění pleti a redukce tuku", url: "/pages/zakrok-exion", img: "bricho.jpg", kw: "exion radiofrekvence ultrazvuk zpevneni tuk telo" },
{ title: "Laserová epilace", sub: "Trvalé odstranění chloupků", url: "/pages/zakrok-laserova-epilace", img: "laserova_epilace_square.png", kw: "laserova epilace chloupky zarustani podpazi bikiny" },
{ title: "Odstranění tetování", sub: "Laserové odstranění tetování", url: "/pages/zakrok-laserove-odstraneni-tetovani", img: "odstraneni_tetovani.jpg", kw: "tetovani odstraneni laser cover-up" },
{ title: "Obličej", sub: "Kategorie zákroků", url: "/pages/oblicej", img: "01_Hlava_a_oblicej.png", kw: "oblicej face tvar lift vrasky" },
{ title: "Tělo", sub: "Kategorie zákroků", url: "/pages/telo", img: "02_Telo_a_hubnuti.png", kw: "telo body zpevneni tuk strie" },
{ title: "Prsa & dekolt", sub: "Kategorie zákroků", url: "/pages/prsa-a-dekolt", img: "03_Prsa_dekolt.png", kw: "prsa dekolt cleavage" },
{ title: "Intimní oblast", sub: "Kategorie zákroků", url: "/pages/intimni-oblast", img: "07_Intimni_oblast.png", kw: "intimni intim labia" },
{ title: "Vlasy & ochlupení", sub: "Kategorie zákroků", url: "/pages/vlasy-a-ochlupeni", img: "05_Laserova_osetreni.png", kw: "vlasy ochlupeni epilace prp mezoterapie" },
{ title: "Zdraví & prevence", sub: "Kategorie zákroků", url: "/pages/zdravi-a-prevence", img: "04_Zily_a_cevy.png", kw: "zdravi prevence hyperhidroza zily dermatoskopie" },
{ title: "Estetické korekce", sub: "Kategorie zákroků", url: "/pages/esteticke-korekce", img: "09_Beauty_zone.png", kw: "esteticke korekce tetovani jizvy" },
{ title: "Pro muže", sub: "Kategorie zákroků", url: "/pages/pro-muze", img: "08_Pro_muze.png", kw: "pro muze men muz" },
{ title: "Konzultace", sub: "Doporučení od lékaře", url: "/pages/konzultace", img: "Microneedling.jpg", kw: "konzultace consultation lekar doporuceni" },
{ title: "Vrásky a stárnoucí pleť", sub: "Co řešíme", url: "/pages/co-resime-vrasky-a-starnouci-plet", img: "Aplikace_botulotoxinu.jpg", kw: "vrasky starnuti antiaging mimika hluboke" },
{ title: "Pevnost a lifting", sub: "Co řešíme", url: "/pages/co-resime-pevnost-a-lifting", img: "ultraformer_zoom.jpg", kw: "pevnost lifting ovaĺ celist krk" },
{ title: "Oči a oční okolí", sub: "Co řešíme", url: "/pages/co-resime-oci-a-ocni-okoli", img: "Bioremodelace.jpg", kw: "oci ocni okoli kruhy slzna ryha vrasky" },
{ title: "Pigmentace, cévky, zarudnutí", sub: "Co řešíme", url: "/pages/co-resime-pigmentace-cevky-zacervenani", img: "lumecca.jpg", kw: "pigmentace cevky kuperoza ruzovka melasma skvrny" },
{ title: "Pleť a její kvalita", sub: "Co řešíme", url: "/pages/co-resime-plet-a-jeji-kvalita", img: "Microneedling.jpg", kw: "plet kvalita textura pory akne" },
{ title: "Rty a kontury obličeje", sub: "Co řešíme", url: "/pages/co-resime-rty-a-kontury-obliceje", img: "vyplne.jpg", kw: "rty kontury obroci ust brada usta" },
{ title: "Zpevnění a kontury těla", sub: "Co řešíme", url: "/pages/co-resime-telo-zpevneni-kontury", img: "bricho.jpg", kw: "telo zpevneni kontury tuk strie bricho" },
{ title: "Epilace a ochlupení", sub: "Co řešíme", url: "/pages/co-resime-epilace-a-ochlupeni", img: "laserova_epilace_square.png", kw: "epilace ochlupeni chloupky zarustani" },
];
function normalize(s) {
return (s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
}
function escapeHtml(s) {
return (s || "").replace(/[&<>"']/g, function (c) {
return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
});
}
function init() {
var form = document.querySelector(".zk-search");
if (!form) return;
var input = form.querySelector('input[type="search"]');
if (!input) return;
var PLACEHOLDER_HINTS = [
"Např. Botox, obličej, vrásky…",
"Např. Profhilo, tělo, pigmentace…",
"Např. Ultraformer, intimní oblast…",
"Např. Laserová epilace, podpaží…",
"Např. Výplně rtů, kontury, objem…",
"Např. Morpheus8, jizvy po akné…",
"Např. EXION, hubnutí, zpevnění…",
"Např. stárnoucí pleť, lifting…",
];
var phIndex = 0;
function rotatePlaceholder() {
if (document.activeElement === input) return;
if (input.value) return;
phIndex = (phIndex + 1) % PLACEHOLDER_HINTS.length;
input.placeholder = PLACEHOLDER_HINTS[phIndex];
}
setInterval(rotatePlaceholder, 2600);
var dropdown = document.createElement("div");
dropdown.className = "zk-search__results";
dropdown.setAttribute("role", "listbox");
document.body.appendChild(dropdown);
function position() {
var r = input.getBoundingClientRect();
dropdown.style.position = "fixed";
dropdown.style.left = r.left + "px";
dropdown.style.top = r.bottom + 8 + "px";
dropdown.style.width = r.width + "px";
}
var activeIndex = -1;
var currentMatches = [];
function render(query) {
var q = normalize(query.trim());
if (!q) {
dropdown.classList.remove("is-open");
dropdown.innerHTML = "";
currentMatches = [];
return;
}
currentMatches = ITEMS.filter(function (item) {
var hay = normalize(item.title + " " + (item.sub || "") + " " + (item.kw || ""));
return hay.indexOf(q) !== -1;
}).slice(0, 8);
activeIndex = -1;
if (currentMatches.length === 0) {
dropdown.innerHTML =
'<div class="zk-search__empty">Nic neodpovídá hledání &bdquo;' +
escapeHtml(query) +
'&ldquo;. <a href="https://upgrade.xdent.cz/wizard/clinic-selection">Zeptejte se AI →</a></div>';
} else {
dropdown.innerHTML = currentMatches
.map(function (m, i) {
var thumb = m.img
? '<span class="zk-search__thumb" style="background-image:url(' + CDN + encodeURIComponent(m.img) + '?width=120)"></span>'
: '<span class="zk-search__thumb zk-search__thumb--blank"></span>';
return (
'<a class="zk-search__item" href="' +
m.url +
'" data-index="' +
i +
'" role="option">' +
thumb +
'<span class="zk-search__item-body">' +
'<span class="zk-search__item-title">' +
escapeHtml(m.title) +
"</span>" +
(m.sub ? '<span class="zk-search__item-sub">' + escapeHtml(m.sub) + "</span>" : "") +
"</span></a>"
);
})
.join("");
}
position();
dropdown.classList.add("is-open");
}
function highlight(idx) {
var items = dropdown.querySelectorAll(".zk-search__item");
for (var i = 0; i < items.length; i++) {
if (i === idx) items[i].classList.add("is-active");
else items[i].classList.remove("is-active");
}
activeIndex = idx;
}
input.addEventListener("input", function () { render(input.value); });
input.addEventListener("focus", function () { if (input.value.trim()) render(input.value); });
input.addEventListener("keydown", function (e) {
if (!currentMatches.length) return;
if (e.key === "ArrowDown") {
e.preventDefault();
highlight(Math.min(activeIndex + 1, currentMatches.length - 1));
} else if (e.key === "ArrowUp") {
e.preventDefault();
highlight(Math.max(activeIndex - 1, 0));
} else if (e.key === "Enter") {
if (activeIndex >= 0) {
e.preventDefault();
window.location.href = currentMatches[activeIndex].url;
} else if (currentMatches[0]) {
e.preventDefault();
window.location.href = currentMatches[0].url;
}
} else if (e.key === "Escape") {
dropdown.classList.remove("is-open");
input.blur();
}
});
document.addEventListener("click", function (e) {
if (!form.contains(e.target) && !dropdown.contains(e.target)) dropdown.classList.remove("is-open");
});
window.addEventListener("scroll", function () { if (dropdown.classList.contains("is-open")) position(); }, { passive: true });
window.addEventListener("resize", function () { if (dropdown.classList.contains("is-open")) position(); }, { passive: true });
}
if (document.readyState === "loading") {
document.addEventListener("DOMContentLoaded", init);
} else {
init();
}
})();

})();

;(function(){

(function () {
"use strict";
function init() {
var groups = document.querySelectorAll(".cenik-categories");
if (!groups.length) return;
groups.forEach(function (group) {
var accs = group.querySelectorAll(":scope > .cenik-acc");
accs.forEach(function (acc) {
acc.addEventListener("toggle", function () {
if (!acc.open) return;
accs.forEach(function (other) {
if (other !== acc && other.open) {
other.removeAttribute("open");
}
});
});
});
});
}
if (document.readyState === "loading") {
document.addEventListener("DOMContentLoaded", init);
} else {
init();
}
})();

})();

;(function(){

(function () {
"use strict";
var SELECTORS = [
".hero-split__cta",
".anchor-nav__cta",
".cena-headline__cta",
".cta-img__cta",
".tech-dev__proc",
".cenik-foot__cta",
".branch-hub__cta",
".upgrade-mega__cta",
].join(", ");
function attach(button) {
if (button.dataset.flairAttached === "1") return;
button.dataset.flairAttached = "1";
var flair = button.querySelector(".button__flair");
if (!flair) {
flair = document.createElement("span");
flair.className = "button__flair";
button.insertBefore(flair, button.firstChild);
}
function getXY(e) {
var r = button.getBoundingClientRect();
return {
x: ((e.clientX - r.left) / r.width) * 100,
y: ((e.clientY - r.top) / r.height) * 100,
};
}
button.addEventListener("mouseenter", function (e) {
var p = getXY(e);
flair.style.transform = "translate(" + p.x + "%, " + p.y + "%) scale(1)";
});
button.addEventListener("mousemove", function (e) {
var p = getXY(e);
flair.style.transform = "translate(" + p.x + "%, " + p.y + "%) scale(1)";
});
button.addEventListener("mouseleave", function (e) {
var p = getXY(e);
flair.style.transform = "translate(" + p.x + "%, " + p.y + "%) scale(0)";
});
}
function init() {
document.querySelectorAll(SELECTORS).forEach(attach);
}
if (document.readyState === "loading") {
document.addEventListener("DOMContentLoaded", init);
} else {
init();
}
setTimeout(init, 600);
})();

})();
